export const ar = {
  dir: 'ltr', lang: 'en', langToggle: 'عربي',
  navBrand: 'Incorporate Pro',
  navLinks: [
    { label: 'About us', href: '#about' },
    { label: 'Packages', href: '#packages' },
    { label: 'Proof of Work', href: '#track' },
    { label: 'FAQ', href: '#faq' },
  ],
  navCta: 'Contact us',

  heroHeadline: 'Expand Your UAE Business Into Saudi Arabia in as Little as 45 Days.',
  heroSub: 'We manage your foreign investment approval and company formation from start to finish, so you can focus on growing your business.',
  heroCta2: 'Service Inquiries',
  heroBadges: [
    'Licensed Saudi attorney',
    '30 to 45 day completion',
    'No hidden fees',
  ],

  pkg1Available: 'Available now',
  pkg1Name: 'Gateway Business Launch',
  pkg1Desc: 'Everything a foreign investor needs to launch a compliant Saudi company.',
  pkg1Price: '44,000',
  pkg1Currency: 'AED',
  pkg1Sub: '3 Installments Payment Plan',
  pkg1Feats: [
    'MISA Investment Approval Filing',
    'Commercial Registration Assistance',
    'Articles of Association (AOA)',
    'Commercial Name Reservation',
    'Assistance Selecting Company Activities',
  ],
  pkg1Bonus: [
    'VAT Registration Support (ZATCA)',
    'Zakat Registration Support (ZATCA)',
    '12 Hour Support Response',
  ],
  pkg1BonusLabel: 'Bonus',
  pkg1Cta: 'Get your free business roadmap',
  pkg1WaMsg: 'Send your free business launch roadmap',

  pkg2Badge: 'Coming soon',
  pkg2Name: 'International Business Setup',
  pkg2Desc: 'Multi jurisdiction formation and cross border structuring for global groups.',
  pkg2WaitlistText: 'We are expanding beyond the Kingdom. Register your interest and we will notify you the moment International Business Setup is available with priority onboarding for early clients.',
  pkg2Cta: 'Join the waitlist',
  pkg2PricingSoon: 'Pricing announced soon',

  stats: [
    { value: '30 to 45', label: 'Days to completion' },
    { value: '15', label: 'Clients per cycle (max)' },
    { value: '100%', label: 'Remote setup' },
    { value: '0', label: 'Hidden fees' },
  ],

  aboutEyebrow: 'About us',
  aboutTitle: 'Not just registration. A solid legal foundation.',
  aboutBody: [
    'Expanding into Saudi Arabia is not just about registering a company. It is about building it on the right legal foundation.',
    'Unlike traditional business setup providers, we are a licensed Saudi legal team with hands on experience in corporate formation, licensing, and regulatory compliance. You are not simply hiring someone to process paperwork. You are working directly with a legal professional who ensures your business is structured correctly from day one.',
    'To maintain the highest level of service, we work with no more than 15 clients per service cycle. we do not continue accepting new clients while my current clients are still in progress. Our focus remains on completing every engagement thoroughly before opening the next cycle.',
    'When you work with us, your business is not just launched. It is built with confidence.',
  ],
  aboutBadge: 'Licensed Attorney',
  aboutReasons: [
    { title: 'Licensed Saudi attorney', desc: 'Your setup is led and signed off by a licensed member of the legal profession in Saudi Arabia.' },
    { title: 'Only 15 clients per cycle', desc: 'We deliberately cap our caseload so every client receives senior hands on attention throughout.' },
    { title: '30 to 45 day completion', desc: 'A disciplined, predictable timeline from application to a fully registered operational entity.' },
    { title: 'No Hidden Fees', desc: 'Your service fee is fixed and transparent, while all processing and certificate fees are clearly disclosed upfront.' },
  ],
  aboutAuthorities: ['Ministry of Investment', 'Ministry of Foreign Affairs', 'Ministry of Justice', 'Saudi Competitiveness and Business Center'],

  pkgEyebrow: 'Packages',
  pkgTitle: 'One fixed fee. Everything included.',
  pkgDesc: 'All fees are clearly disclosed upfront.',

  trackEyebrow: 'Proof of Work',
  trackTitle: 'Completed formations.',
  trackDesc: 'Official portal records of completed company formations and commercial name registrations.',

  faqEyebrow: 'Questions',
  faqTitle: 'Everything you need to know.',
  faqs: [
    { q: 'Can I set up my Saudi company remotely?', a: 'Yes. The entire process from initial contact to your final licenses and certificates can be completed remotely. We handle filings on your behalf so a visit to the Kingdom is not required to incorporate.' },
    { q: 'Can foreigners own 100% of a company in Saudi Arabia?', a: 'Yes. Under the MISA foreign investment framework foreign investors hold full ownership.' },
    { q: 'How long does the setup take?', a: 'Our standard completion time is 30 to 45 days from the point your documents are ready depending on your activity and the relevant authorities processing times.' },
    { q: 'What exactly is included in the 44,000 AED fee?', a: 'The Gateway Business Launch package includes your MISA Investment Approval Filing, Commercial Registration Assistance, Articles of Association, and commercial name reservation. The fee is payable in 3 equal installments. As a bonus we also include VAT Registration Support, Zakat Registration Support and 12 hour support at no additional cost.' },
    { q: 'Why do you only take 15 clients per cycle?', a: 'We deliberately cap our caseload so every client is handled personally by a licensed attorney with senior attention. It keeps quality high and timelines predictable rather than processing volume.' },
    { q: 'Which authorities do you work with?', a: 'Your setup complies with the Ministry of Investment, Ministry of Foreign Affairs, Ministry of Justice, and the Saudi Competitiveness and Business Center ensuring your entity is fully recognized and in good standing.' },
  ],

  conEyebrow: 'Service Inquiries',
  conTitle: 'Get in Touch',
  conSub: 'Reach out to our team today and we will guide you through every step toward establishing your company.',
  formName: 'Full Name',
  formEmail: 'Email',
  formPhone: 'Phone Number',
  formCompany: 'Company Name (optional)',
  formMessage: 'How can we help?',
  formSubmit: 'Send Request',
  formSuccess: 'Thank you! We will be in touch shortly.',
  formNamePh: 'John Smith',
  formEmailPh: 'name@company.com',
  formPhonePh: '+1 XXX XXX XXXX',
  formCompanyPh: 'Company name',
  formMessagePh: 'Tell us about your goals...',

  footerDesc: 'Licensed legal services for company formation in Saudi Arabia. Guided by a licensed attorney with transparent pricing and no hidden fees.',
  footerServices: 'Services',
  footerServicesLinks: ['Company Formation', 'MISA Approval Filing', 'Commercial Registration Assistance', 'VAT and Zakat Support'],
  footerContact: 'Contact',
  footerEmail: 'malshowyah@gmail.com',
  footerPhone: '+966 50 147 2531',
  footerCopy: '© 2026 Incorporate Pro. All rights reserved.',
  footerPrivacy: 'Privacy Policy',
  footerTerms: 'Terms of Service',
};

export const en = ar;
